<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap check-in"
  >
    <h3 v-if="title != null">
      {{ title }}
    </h3>
    <el-form
      :model="userData"
      :rules="rules"
      label-position="top"
      class="checkin-form pre-reg"
      :ref="formName"
      autocomplete="off"
      @submit.native.prevent
    >
      <el-row class="block">
        <LoginForm
          :dob.sync="userData.dob"
          ref="loginForm"
          @sendData="submitForm"
        />
        <el-form-item class="submit-container">
          <el-form-item class="submit-btn">
            <el-button
              type="primary"
              @click="submitForm('checkInLinkForm')"
            >
              Continue
            </el-button>
          </el-form-item>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row class="info">
      Click the Continue button to proceed with Pre-Check In
    </el-row>
    <el-row
      class="reg-complete"
      v-show="completedForm"
    >
      <div class="popup">
        <div class="popup-overlay" />
        <div class=" popup-content">
          <p class="title">
            {{ completeTitle }}
          </p>
          <p>
            {{ completeMessage }}
            <el-link
              :href="'tel:1' + phoneLink"
            >
              {{ completePhone }}
            </el-link>
          </p>
        </div>
      </div>
    </el-row>
  </el-row>
</template>

<script>

import LoginForm from '../components/LoginForm';
import store from "../../store";

export default {
  name: "CheckInLink",
  components: {
    LoginForm
  },
  data: () => ({
    fullscreenLoading: false,
    userData: {},
    dob: '',
    patientNumber: null,
    patientId: null,
    patientToken: null,
    currentStepRoute: 'CheckIn',
    lastStepRoute: 'ThankYou',
    completeTitle: '',
    completeMessage: '',
    completePhone: '',
    phoneLink: null,
    completedForm: false,
    title: null,
    routerName: 'UploadPhoto',
    formName: 'checkInLinkForm',
    rules: {
      dob: [
        { required: true, message: 'Please input your Date of Birth', trigger: 'blur' }
      ],
    },
  }),
  created(){
    this.setProgressBar();
    this.title = this.$route.meta.title;
    this.completeTitle = this.$route.meta.completeTitle;
    this.completeMessage = this.$route.meta.completeMessage;
    this.completePhone = this.$route.meta.completePhone;
    this.$set(this, 'phoneLink', this.completePhone.replace(/[^0-9]/g, ''));
    this.patientToken = this.$route.params.epn;
    this.saveStatisticData(this.getSessionId(), {
      active_step: this.activeStep,
      epn: this.patientToken,
      authSource: 'Email'
    });
  },
  watch: {
    'userData.dob': function (val){
      if (val.trim().length) this.changeField({dob: val});
    }
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validDate = true;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          this.saveStatisticData(this.getSessionId(), {
            submit_CheckIn: 'true'
          });
          if (this.$refs.loginForm.checkDate(this.userData.dob)) {
              this.checkIn();
          } else {
            this.fullscreenLoading = false;
            return false;
          }
        }
      });
      return false;
    },
    checkIn () {
      this.fullscreenLoading = true;
      this.$axios("/Patient/Authenticate", {
        method: "POST",
        data: {
          dateOfBirth: this.userData.dob,
          encodedNumber: this.patientToken,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          sessionStorage.setItem("patientApiToken", response.data.data.accessToken);
          const tokenData = this.parseToken(response.data.data.accessToken);

          this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
            pid: tokenData.patient_id
          }).then((response) => {
            if (response.data.appData) {
              this.userData = response.data.appData;

              this.saveStatisticData(this.getSessionId(), {
                patient_number: tokenData.patient_number,
                login: 'true',
                dob: this.formattedDate(this.userData.dob),
                fname: this.userData.fname,
                lname: this.userData.lname
              });

              if (this.userData.active_route) {
                if (this.userData.active_route == this.currentStepRoute) {
                  this.$router.push({
                    name: this.routerName,
                    params: {
                      patientNumber: tokenData.patient_number,
                    },
                  });
                } else if (this.userData.active_route == this.lastStepRoute) {
                  this.completedForm = true;
                  this.fullscreenLoading = false;
                } else {
                  this.$router.push({
                    name: this.userData.active_route,
                    params: {
                      patientNumber: tokenData.patient_number,
                    },
                  });
                }
              } else {
                this.$router.push({
                  name:  this.routerName,
                  params: {
                    patientNumber: tokenData.patient_number,
                  },
                });
              }
            } else {
              this.getDataByPatientNumber().then(() => {
                this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/savePatientDataByEPN',{
                  patientData: store.getters.patientData
                }).then((response) => {
                  if (response.data.isSuccess) {
                    this.$router.push({
                      name:  this.routerName,
                      params: {
                        patientNumber: store.getters.patientData.patientNumber,
                      },
                    });
                  } else {
                    this.fullscreenLoading = false;
                    this.setMessage(this.$t('common.errors.fail'));
                    this.goToMainPage();
                  }
                });
              }).catch(() => {
                this.fullscreenLoading = false;
                this.setMessage(this.$t('common.errors.fail'));
              });
            }
          }).catch(() => {
            this.setMessage('Oops, something went wrong!');
            this.fullscreenLoading = false;
          });
        } else {
          this.setMessage('Can\'t get your personal data!');
          this.fullscreenLoading = false;
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage('Please enter the correct data!');
      });
    },
  }
};
</script>
